import { useQuery } from '@tanstack/react-query';
import { IGetOnsiteInterviewStatusCountPayload } from '../types';
import { PermanentJobsService } from '../services';
import { OnsiteInterviewStatus } from '../enums';
import { useEffect } from 'react';
import { showErrorMessage } from '~/domain/utils';

export const useGetOnsiteInterviewStatusCount = (
  payload: IGetOnsiteInterviewStatusCountPayload,
) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    initialData: {
      [OnsiteInterviewStatus.ActionNeeded]: 0,
      [OnsiteInterviewStatus.Cancelled]: 0,
      [OnsiteInterviewStatus.Completed]: 0,
      [OnsiteInterviewStatus.Open]: 0,
      [OnsiteInterviewStatus.Scheduled]: 0,
    },
    queryKey: ['GET_ONSITE_INTERVIEW_STATUS_COUNT', payload.jobPostingId],
    queryFn: async () => PermanentJobsService.getOnsiteInterviewStatusCount(payload),
    retry: false,
    staleTime: 0,
  });

  useEffect(() => {
    if (isError) {
      showErrorMessage({ error });
    }
  }, [isError, error]);

  return {
    statistic: data,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
